let numberOfBlocks = 1;

const isObject = function (a) {
  return (!!a) && (a.constructor === Object);
};


function writeToList(data, list) {
  if (isObject(data)) {
    for (let key in data) {
      if (isObject(data[key])) {
        list += '<div class="json-response-item">' + '"' + key + '"' + ':' + ' {';
        numberOfBlocks += 1;
        list = writeToList(data[key], list);
      } else {
        if (key === 'redirect-url') {
          list += '<div class="json-response-item">' + '"' + key + '"' + ':' + ' "' + '<a class="json-response-item__link" target="_blank" href="'
            + data[key] + '"' + '>' + data[key] + '</a>' + '"' + ',' + '</div>';
        } else {
          list += '<div class="json-response-item">' + '"' + key + '"' + ':' + ' "' + data[key] + '"' + ',' +
            '</div>';
        }
      }
    }
  }
  return list;
}

export default function showResponseInJsonFormat(info) {
  let list = '<div>' + '{' + '</div>';
  list = writeToList(info, list);

  for (let i = 0; i < numberOfBlocks; i++) {
    list += '}</div>'
  }
  numberOfBlocks = 1;
  return list;
}
